import moment from 'moment-timezone';
import {
  doTitle,
  toggleLabelsButton,
  toggleShowAllButton,
  toggleButtonText,
  updateUserOptionsEventSortOrder,
  swapSeriesOrderAndLegend,
  cycleAreaSortType,
  setCycleButtonText,
} from './Common';
import {
  sortingTypes,
  sortingOrder,
  sortingTypeBtnText,
  sortingOrderBtnText,
} from '../constants/common';

const AreaChartCommonConfig = (
  chartSeries,
  options,
  fromDashboard = false,
  showCumulative,
  showSort,
  sortOrder,
  sortType,
  triggerLabels
) => {
  const areaChartConfig = {
    groups: [!fromDashboard && 'zoomSync', options.group],
    time: {
      getTimezoneOffset(timestamp) {
        return -moment.tz(timestamp, options.timezone).utcOffset();
      },
    },
    eventSort: {
      sortOrder,
      sortType,
    },
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          menuItems: [
            'printChart',
            'separator',
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
          ],
        },
        Fullscreen: {
          verticalAlign: 'bottom',
          align: 'left',
          text: 'full screen',
          onclick() {
            this.fullscreen.toggle();
          },
        },
        showAll: {
          verticalAlign: 'bottom',
          align: 'left',
          text: doTitle('show all', false),
          onclick() {
            if (this.series.reduce((r, s) => s.visible && r, true)) {
              this.series.forEach((s) => {
                s.setVisible(false, false);
              });
            } else {
              this.series.forEach((s) => {
                s.setVisible(true, false);
              });
            }
            toggleShowAllButton(this);
            this.redraw();
          },
        },
        ...(showSort && {
          toggleSortOrder: {
            verticalAlign: 'bottom',
            align: 'left',
            text:
              sortOrder === sortingOrder.ASCENDING
                ? sortingOrderBtnText.ASCENDING
                : sortingOrderBtnText.DESCENDING,
            onclick() {
              this.userOptions.eventSort = updateUserOptionsEventSortOrder(this);

              swapSeriesOrderAndLegend(this, chartSeries, this.userOptions.eventSort);

              toggleButtonText(
                this.exportSVGElements,
                this.userOptions.eventSort.sortOrder,
                sortingOrder.ASCENDING,
                sortingOrderBtnText.ASCENDING,
                sortingOrderBtnText.DESCENDING
              );

              this.redraw();
            },
          },
        }),
        ...(showSort && {
          toggleSortType: {
            verticalAlign: 'bottom',
            align: 'left',
            text:
              {
                [sortingTypes.NAME]: sortingTypeBtnText.NAME,
                [sortingTypes.SUM]: sortingTypeBtnText.SUM,
                [sortingTypes.VOLATILITY]: sortingTypeBtnText.VOLATILITY,
              }[sortType] ?? sortingTypeBtnText.NAME,
            onclick() {
              this.userOptions.eventSort = cycleAreaSortType(this);

              swapSeriesOrderAndLegend(this, chartSeries, this.userOptions.eventSort);

              const sortTypeOptions = [
                { value: sortingTypes.NAME, text: sortingTypeBtnText.NAME },
                { value: sortingTypes.SUM, text: sortingTypeBtnText.SUM },
                { value: sortingTypes.VOLATILITY, text: sortingTypeBtnText.VOLATILITY },
              ];
              setCycleButtonText(
                this.exportSVGElements,
                this.userOptions.eventSort.sortType,
                sortTypeOptions
              );

              this.redraw();
            },
          },
        }),
        ...(fromDashboard && {
          labels: {
            verticalAlign: 'bottom',
            align: 'left',
            text: doTitle('labels', true),
            onclick() {
              if (!this.labels) {
                this.zoomOut();
              }
              toggleLabelsButton(this);
              triggerLabels();
            },
          },
        }),
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: null,
      },
    },
    title: {
      text: '',
    },
  };

  if (fromDashboard) {
    delete areaChartConfig.exporting.buttons.Fullscreen;
  }

  if (fromDashboard && triggerLabels === undefined) {
    delete areaChartConfig.exporting.buttons.labels;
  }

  return areaChartConfig;
};

export default AreaChartCommonConfig;
